import React from "react";
import { PageHero, ServicesGrid, CTABlock, TrustPointsRow } from "@/components/Sections";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/data";

export default function Tjanster() {
  return (
    <>
      <PageHero
        eyebrow="Tjänster"
        title="Städning anpassad efter er verksamhet"
        intro="Rena Tjänster hjälper företag, fastigheter och verksamheter i nordvästra Skåne med städning som anpassas efter lokaler, öppettider och rutiner. Vi arbetar noggrant, flexibelt och med fokus på ett jämnt och pålitligt resultat."
        image={ASSETS.officeCleaning}
        imageAlt="Kontorsstädning av Rena Tjänster"
      >
        <Link to="/kontakt#offertformular" data-testid="tjanster-hero-cta">
          <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
            Begär offert
          </Button>
        </Link>
      </PageHero>

      <ServicesGrid
        title="Våra städtjänster"
        eyebrow="Översikt"
      />

      <TrustPointsRow />

      <CTABlock
        title="Behöver er verksamhet hjälp med städning?"
        description="Vi kommer gärna ut på plats för en kostnadsfri genomgång och tar fram ett upplägg som passar er verksamhet."
      />
    </>
  );
}
